import React/*, { Component }*/ from 'react';
import {/*Container,*/Row/*, Col*/} from 'reactstrap';
//import {withRouter} from "react-router-dom";
//import Modes from "../../exercises/mode/Modes";
//import ModeItem from "../modeItem/ModeItem";
//import {getRandomIntegerWithRange} from "../../exercises/Random";
//import {formatNumberForDisplay} from "../../ui/NumberFormatter";
//import DebugHelperElement from "../DebugHelperElement";
//import ArithmeticElement from "../modes/ArithmeticElement";
import NumberSystems from "../../exercises/NumberSystems";
import KeyboardElement from "./KeyboardElement";
import Constants from "../constants";
import "../../style/Keyboard.sass"
import "../../style/Ripple.sass"

const decimalInput = ["7","8","9","4","5","6","1","2","3","0"];
const octalInput = ["7","6","4","5","3","2","1","0"];
const hexInput = ["A","B","C","D","E","F", "7","8","9","4","5","6","1","2","3","0"];
const binaryInput = ["1","0"];
class Keyboard extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            keyboardElements: []
        };
    }

    componentDidMount() {
        this.updateKeyboardElements();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps !== this.props){
            this.updateKeyboardElements();
        }
    }

    getKeyboard = (spanSize, elements) => {
        const keyboardElements = [];
        keyboardElements.push(
            <KeyboardElement
                inputCallback={this.props.inputCallback}
                key={"keyboard-toggle-sign"}
                spanSize={12}
                value={Constants.TOGGLE_SIGN}
                innerElement={<span>+ / -</span>}
            />
        );
        elements.forEach((element)=>{
            keyboardElements.push(
                <KeyboardElement
                    inputCallback={this.props.inputCallback}
                    key={"keyboard-"+element}
                    spanSize={spanSize}
                    value={element}
                    innerElement={<span>{element}</span>}
                />
            )
        });
        keyboardElements.push(
            <KeyboardElement
                inputCallback={this.props.inputCallback}
                key={"keyboard-comma"}
                spanSize={spanSize}
                value={Constants.COMMA}
                innerElement={<span>.</span>}
            />
        );

        keyboardElements.push(
            <KeyboardElement
                inputCallback={this.props.inputCallback}
                key={"keyboard-backspace"}
                spanSize={spanSize}
                value={Constants.INPUT_BACKSPACE}
                innerElement={<i className="material-icons">backspace</i>}
            />
        );
        return keyboardElements;
    };
    updateKeyboardElements = () => {
        const currentNumberSystem = this.props.mode.getExercise().getResultAtIndex(this.props.index).getNumberSystem();
        let keyboardElements;
        switch(currentNumberSystem){
            case NumberSystems.BINARY:
                keyboardElements = this.getKeyboard(6, binaryInput);
                break;
            case NumberSystems.OCTAL:
                keyboardElements = this.getKeyboard(6, octalInput);
                break;
            case NumberSystems.DECIMAL:
                keyboardElements = this.getKeyboard(4, decimalInput);
                break;
            case NumberSystems.HEXADECIMAL:
                keyboardElements = this.getKeyboard(4, hexInput);
                break;
            default:
                throw new Error("Invalid Number System "+currentNumberSystem);

        }
        this.setState({keyboardElements: keyboardElements})
    };

    render(){
        return <div className={"keyboard-container"}>
            <Row>
                {this.state.keyboardElements}
            </Row>
        </div>
    }
}
export default Keyboard